"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCallerID = exports.updateCallerInbound = exports.updatePhoneNumber = exports.updateCallStatus = exports.resetUAState = exports.newUAConnection = exports.getCallerIDS = exports.CONNECT = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const jssip_1 = require("jssip");
const comunicationConstants_1 = require("../../constants/comunicationConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const communicationBoxConstants_1 = require("./communicationBoxConstants");
const network_1 = require("../../utils/network");
const constants_1 = require("../../constants/constants");
const utils_1 = require("../../utils/utils");
const initialState = {
    ua: null,
    voipCallStatus: communicationBoxConstants_1.IDLE,
    phoneNumber: communicationBoxConstants_1.COUNTRY_CODE,
    isValidPhoneNumber: false,
    callerInbound: '',
    callerIDs: [],
    loadingStatus: typesConstants_1.PENDING_STATUS,
    selectedCallerID: null,
    currentPage: null,
    nextPage: null,
    previousPage: null,
    totalPages: null,
    totalEntries: null,
    pageSize: 10,
};
exports.CONNECT = 'communication/connect';
exports.getCallerIDS = toolkit_1.createAsyncThunk('communication/caller-ids/', async ({ provider, number, is_active, page }, { getState, rejectWithValue }) => {
    try {
        const url = communicationBoxConstants_1.ASTERISK_PHONE_NUMBER_URL;
        const { auth } = getState();
        const queryParams = utils_1.encodeUrlParams({
            ...{ provider: String(provider) },
            ...{ is_active: String(is_active) },
            ...(page && { page: String(page) }),
            ...(number && { number__contains: number }),
        });
        const urlPath = `${url}?${queryParams}`;
        return await network_1.fetchBackend(urlPath, constants_1.HTTP.GET, auth.token)
            .then(network_1.checkHttpStatus)
            .then(network_1.parseJSON);
    }
    catch (err) {
        return network_1.handleDefaultError(err, rejectWithValue);
    }
});
const communicationSlice = toolkit_1.createSlice({
    name: 'communication',
    initialState,
    reducers: {
        newUAConnection: (state, { payload }) => {
            const socket = new jssip_1.WebSocketInterface(`wss://${comunicationConstants_1.SERVER_URL}:${comunicationConstants_1.SERVER_PORT}/ws`);
            const { voipUserId, voipPassword } = payload;
            const configuration = {
                sockets: [socket],
                uri: `sip:${voipUserId}@${comunicationConstants_1.SERVER_URL}`,
                password: voipPassword,
                authorizationUser: voipUserId,
                displayName: voipUserId,
                register: true,
                register_expires: 3600, // registrations will last an hour.
            };
            return { ...state, ua: new jssip_1.UA(configuration) };
        },
        resetUAState(state) {
            return {
                ...state,
                ua: null,
            };
        },
        updateCallStatus(state, { payload }) {
            return { ...state, voipCallStatus: payload.status };
        },
        updateCallerInbound(state, { payload }) {
            return { ...state, callerInbound: payload.callerInbound };
        },
        updateCallerID(state, { payload }) {
            return { ...state, selectedCallerID: payload };
        },
        updatePhoneNumber(state, { payload }) {
            return { ...state, ...payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.getCallerIDS.pending, (state) => ({
            ...state,
            loadingStatus: typesConstants_1.PENDING_STATUS,
        }))
            .addCase(exports.getCallerIDS.fulfilled, (state, { payload }) => ({
            ...state,
            loadingStatus: typesConstants_1.SUCCEEDED_STATUS,
            callerIDs: payload.results,
            currentPage: payload.current,
            nextPage: payload.next,
            previousPage: payload.previous,
            totalPages: payload.total_pages,
            totalEntries: payload.total_entries,
            pageSize: payload.page_size,
        }))
            .addCase(exports.getCallerIDS.rejected, (state, { payload }) => {
            const errorMessage = utils_1.convertObjToPlainString(payload.errorObject || {});
            return {
                ...state,
                loadingStatus: typesConstants_1.FAILED_STATUS,
                errorMessage,
            };
        });
    },
});
_a = communicationSlice.actions, exports.newUAConnection = _a.newUAConnection, exports.resetUAState = _a.resetUAState, exports.updateCallStatus = _a.updateCallStatus, exports.updatePhoneNumber = _a.updatePhoneNumber, exports.updateCallerInbound = _a.updateCallerInbound, exports.updateCallerID = _a.updateCallerID;
exports.default = communicationSlice.reducer;
